(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.LiveQuoteTool
        .factory('ServiceModel', ['$http', '$q', function ($http, $q) {
            var ServiceModel = function () {

            };

            ServiceModel.prototype = {
                _items: [],
                /**
                 * Possible Types are:
                 *
                 * - hospital
                 * - extras
                 *
                 * @param type
                 * @returns {deferred.promise|{then, always}}
                 */
                byType: function (type) {
                    var deferred = $q.defer();
                    var scope = this;

                    var url = false;
                    if (type === 'hospital') {
                        url = '/api/v1/product/HospitalServices/Get';
                    }
                    else if (type === 'extras') {
                        url = '/api/v1/product/ExtrasServices/Get';
                    }

                    if (url === false) {
                        url = '/static/js/src/Angular/thfLiveQuoteTool/json/services/' + type + '.json';
                    }


                    $http.get(url, {
                        cache: true
                    })
                        .success(function (serviceGroupArray) {
                            deferred.resolve(serviceGroupArray);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                }
            };

            return new ServiceModel();
        }]);

})(angular, window);
